export interface AdminMenuItem {
  label: string;
  icon: string;
  routerLink: string[];
}

export interface AdminMenuGroup {
  label: string;
  items: AdminMenuItem[];
}

interface UserRole {
  RoleShortName?: string;
  IsActive?: boolean;
}

const menuGroups: AdminMenuGroup[] = [
  {
    label: 'Home',
    items: [
      { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard/admindashboard'] },
      { label: 'User And Course Report', icon: 'pi pi-fw pi-file', routerLink: ['/dashboard/userAndCoursesReport'] }
    ]
  },
  {
    label: 'UMS',
    items: [
      { label: 'User', icon: 'pi pi-fw pi-users', routerLink: ['/ums/user'] },
      { label: 'Roles', icon: 'pi pi-fw pi-shield', routerLink: ['/ums/role'] }
    ]
  },
  {
    label: 'Courses',
    items: [
      { label: 'Add Courses', icon: 'pi pi-fw pi-plus-circle', routerLink: ['/courses/addCourses'] },
      { label: 'Courses List', icon: 'pi pi-fw pi-list', routerLink: ['/courses/CoursesList'] }
    ]
  }
];

const roleRoutes: Record<string, string[]> = {
  SADMN: menuGroups.flatMap(group => group.items.map(item => item.routerLink[0])),
  ADMN: ['/dashboard/admindashboard', '/dashboard/userAndCoursesReport'],
  CRSCRT: ['/courses/addCourses', '/courses/CoursesList'],
  USRCRTN: ['/ums/user','/ums/role'],
  STDNT: []
};

export function getAdminMenuForRoles(userRoles: UserRole[] | null | undefined): AdminMenuGroup[] {
  const allowedRoutes = new Set<string>();
  for (const role of userRoles ?? []) {
    if (role.IsActive === false) continue;
    for (const route of roleRoutes[role.RoleShortName?.toUpperCase() ?? ''] ?? []) {
      allowedRoutes.add(route);
    }
  }

  return menuGroups
    .map(group => ({ ...group, items: group.items.filter(item => allowedRoutes.has(item.routerLink[0])) }))
    .filter(group => group.items.length > 0);
}

export function getDefaultAdminRoute(userRoles: UserRole[] | null | undefined): string | null {
  const menu = getAdminMenuForRoles(userRoles);
  return menu[0]?.items[0]?.routerLink[0] ?? null;
}
